import { Link } from "gatsby"
import PropTypes from "prop-types"
import React, { Component } from 'react'
import Menu from "../components/menu";
import Backdrop from "../components/backdrop";

import "./header.scss"

class Header extends Component {
  state = {
    menuToggle:false,
  };
  menuToggleClick = () => {
    this.setState((prevState)=>{
      return {menuToggle: !prevState.menuToggle}
    });
  };
  backDropClick = () => {
    this.setState({menuToggle:false})
  };
  notiToggleClick = () => {
    alert('공사중입니다...!');
  };

  render() {
    let menuPopup;
    let backPopup;
    if(this.state.menuToggle) {
      menuPopup=<Menu click={this.backDropClick} alert={this.notiToggleClick}/>
      backPopup=<Backdrop click={this.backDropClick}/>
    }

    return (
      
      <>
        <header id="Header">
          
          <div id="Header_Component">

            <div className="logo media">
              <Link to="/">
                {this.props.siteTitle}
              </Link>
            </div>

            <nav className="Navlist">
              <div className="Navlist_Wrapper">
                <Link to="/" className="work">
                  works
                </Link>
                <Link to="/" className="blog" onClick={this.notiToggleClick}>
                  blog
                </Link>
                <Link to="/about" className="about">
                  about
                </Link>
              </div>
            </nav>
            <div className="mobile_menu" onClick={this.menuToggleClick}>Menu</div>
            {menuPopup}
            

          </div>
            <div className="Header_logoWord">
              logic to sense
            </div>
          </header>
          {backPopup}
          
        </>
    )
  }
}


export default Header




